import { POST } from 'src/network/apiHandler';
import config from 'src/globals';
import {
  FETCH_ALL_INVOICES,
  FETCH_INVOICE_BUCKET_METRICS,
  UPLOAD_INVOICE_POD_SINGLE,
  VALIDATE_INVOICE_POD,
} from 'src/api/routes';

const { API_BASE_URL } = config;

export const fetchAllInvoices = async (body) => {
  return POST(`${API_BASE_URL}${FETCH_ALL_INVOICES}`, body);
};

export const fetchInvoiceBucketMetrics = async (body) => {
  return POST(`${API_BASE_URL}${FETCH_INVOICE_BUCKET_METRICS}`, body);
};

export const uploadSinglePOD = async (body) => {
  return POST(`${API_BASE_URL}${UPLOAD_INVOICE_POD_SINGLE}`, body);
};

export const validateInvoicePOD = async (body) => {
  return POST(`${API_BASE_URL}${VALIDATE_INVOICE_POD}`, body);
};
